import universalKioskEnCommon from './universal-kiosk-en-common.json';
import universalKioskFrCommon from './universal-kiosk-fr-common.json';
import universalKioskJaCommon from './universal-kiosk-ja-common.json';
import universalKioskZhtCommon from './universal-kiosk-zht-common.json';
import universalKioskZhsCommon from './universal-kiosk-zhs-common.json';
import webappEnCommon from './webapp-en-common.json';
import webappFrCommon from './webapp-fr-common.json';
import webappJaCommon from './webapp-ja-common.json';
import webappZhtCommon from './webapp-zht-common.json';
import webappZhsCommon from './webapp-zhs-common.json';

export const languageOptions = [
  {
    code: 'en',
    label: 'English',
    nativeLabel: 'English',
    flagCode: 'us',
  },
  {
    code: 'fr',
    label: 'French',
    nativeLabel: 'Français',
    flagCode: 'fr',
  },
  {
    code: 'ja',
    label: 'Japanese',
    nativeLabel: '日本語',
    flagCode: 'jp',
  },
  {
    code: 'zht',
    label: 'Chinese (Traditional)',
    nativeLabel: '繁體中文',
    flagCode: 'hk',
  },
  {
    code: 'zhs',
    label: 'Chinese (Simplified)',
    nativeLabel: '简体中文',
    flagCode: 'cn',
  },
];

const fallbackTranslations = {
  'universal-kiosk': {
    en: {
      common: universalKioskEnCommon,
    },
    fr: {
      common: universalKioskFrCommon,
    },
    ja: {
      common: universalKioskJaCommon,
    },
    zht: {
      common: universalKioskZhtCommon,
    },
    zhs: {
      common: universalKioskZhsCommon,
    },
  },
  webapp: {
    en: {
      common: webappEnCommon,
    },
    fr: {
      common: webappFrCommon,
    },
    ja: {
      common: webappJaCommon,
    },
    zht: {
      common: webappZhtCommon,
    },
    zhs: {
      common: webappZhsCommon,
    },
  },
};

export default fallbackTranslations;
